import React, { useState, useEffect } from "react"
import { useIntl } from "react-intl"
import formatCurrency from "../../helpers/currencyHelper"
import { AlertError, AlertLoading } from '../../helpers/AlertHelper'

import ExpensesService from "../../services/ExpensesService"

import BarChart from "../../components/charts/BarChart"

const ExpensesReports = ({ onChangeDataset, yearFrom = null, yearTo = null }) => {
    const intl = useIntl()
    
    const [expensesDataset, setExpensesDataset] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(null)

    // Fetch expenses dataset
    const fetchExpensesDataset = async () => {
        try {
            const response = await ExpensesService.getExpensesDataset({ yearFrom, yearTo })
            const { labels, datasets } = response.data.dataset

            // Construcción del dataset directamente al obtener los datos
            const formattedDataset = {
                labels,
                datasets: [
                    {
                        label: intl.formatMessage({ id: "expensesTotalAmount", defaultMessage: "Total amount" }),
                        data: datasets[0].data,
                        yAxisID: "y",
                        borderColor: "rgb(53, 162, 235)",
                        backgroundColor: "rgba(53, 162, 235, 0.5)",
                        datalabels: {
                            anchor: 'end',
                            align: 'end',
                            color: '#333',
                            rotation: -45,
                            font: {
                                weight: 'bold',
                                size: 12
                            },
                            formatter: value => formatCurrency(value),
                        },
                    },
                ],
            }

            setExpensesDataset(formattedDataset)
            onChangeDataset({
                ...formattedDataset,
                datasets: [formattedDataset.datasets[0]],
                totalAmountsSum: response.data.dataset.totalAmountsSum,
                totalExpensesSum: response.data.dataset.totalExpensesSum
            })
            setIsLoaded(true)
        } catch (err) {
            setIsLoaded(false)
            setError(err)
        }
    }

    // Re-fetch data on page/perPage change
    useEffect(() => {
        fetchExpensesDataset()
    }, [yearFrom, yearTo])

    return (
        <>
            {error && <AlertError error={error} />}
            {!isLoaded && <AlertLoading isLoaded={isLoaded} />}
            {isLoaded && (
                <BarChart
                    //title={intl.formatMessage({ id: "navExpenses", defaultMessage: "Customers Expenses" })}
                    data={expensesDataset}
                />
            )}
        </>
    )
}

export default ExpensesReports